// @flow

import _ from 'lodash';
import { DashboardState, DashboardAction } from 'stores/flow-type/dashboard-v3.type';

import {
  GET_DASHBOARD_BLOCKS_REQUEST,
  GET_DASHBOARD_BLOCKS_SUCCESS,
  GET_DASHBOARD_BLOCKS_FAILURE,
  GET_DASHBOARD_COMPONENTS_REQUEST,
  GET_DASHBOARD_COMPONENTS_SUCCESS,
  GET_DASHBOARD_COMPONENTS_FAILURE,
  GET_CAMPAIGN_BANNERS_REQUEST,
  GET_CAMPAIGN_BANNERS_SUCCESS,
  GET_CAMPAIGN_BANNERS_FAILURE,
  GET_IN_APP_SPOTLIGHT_REQUEST,
  GET_IN_APP_SPOTLIGHT_SUCCESS,
  GET_IN_APP_SPOTLIGHT_FAILURE,
  GET_CHANGE_LOGS_REQUEST,
  GET_CHANGE_LOGS_SUCCESS,
  GET_CHANGE_LOGS_FAILURE,
  GET_CROSS_SELL_UP_SELL_REQUEST,
  GET_CROSS_SELL_UP_SELL_SUCCESS,
  GET_CROSS_SELL_UP_SELL_FAILURE,
  FEEDBACK_REQUEST,
  FEEDBACK_SUCCESS,
  FEEDBACK_FAILURE,
  PROCESS_DISMISS_BLOCK_REQUEST,
  PROCESS_DISMISS_BLOCK_SUCCESS,
  PROCESS_DISMISS_BLOCK_FAILURE,
  CONFIRM_DISMISS_BLOCK,
  UPDATE_DASHBOARD_BLOCK,
  IM_IN_FEEDBACK_5TARS
} from 'stores/flow-type/dashboard-v3.type';
import { DASHBOARD_BLOCKS_DEFAULT } from 'src/constants/dashboard-layout.js';

const initialState: DashboardState = {
  loading: false,
  success: false,
  dashboardComponentsLoading: false,
  dashboardComponentsSuccess: false,
  campaignBannerLoading: false,
  campaignBannerSuccess: false,
  inAppSpotlightLoading: false,
  inAppSpotlightSuccess: false,
  feedbackLoading: [],
  feedbackSuccess: [],
  dismissLoading: [],
  dismissSuccess: [],
  error: undefined,
  campaignBanners: [],
  recommendedApps: [],
  dashboardBlocks: DASHBOARD_BLOCKS_DEFAULT,
  dashboardComponents: {},
  features: [],
  gettingFeatures: false,
  getFeaturesSuccess: false,
  changeLogs: {},
  gettingChangeLogs: false,
  getChangeLogsSuccess: false,
  isShowPopupImIn: false
};

const dashboardReducers = (state: DashboardState = initialState, action: DashboardAction) => {
  switch (action.type) {
    // Get dashboard blocks
    case GET_DASHBOARD_BLOCKS_REQUEST:
      return { ...state, loading: true };
    case GET_DASHBOARD_BLOCKS_SUCCESS: {
      const { data } = action.payload;

      return { ...state, loading: false, error: undefined, dashboardBlocks: data };
    }
    case GET_DASHBOARD_BLOCKS_FAILURE: {
      const { data } = action.payload;

      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
        dashboardBlocks: data
      };
    }
    // Get campaign banners
    case GET_CAMPAIGN_BANNERS_REQUEST:
      return { ...state, campaignBannerLoading: true };
    case GET_CAMPAIGN_BANNERS_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        campaignBannerLoading: false,
        campaignBannerSuccess: true,
        error: undefined,
        campaignBanners: data
      };
    }
    case GET_CAMPAIGN_BANNERS_FAILURE: {
      return {
        ...state,
        campaignBannerLoading: false,
        campaignBannerSuccess: false,
        error: action.payload,
        campaignBanners: []
      };
    }
    // get recommended apps
    case GET_IN_APP_SPOTLIGHT_REQUEST:
      return { ...state, inAppSpotlightLoading: true };
    case GET_IN_APP_SPOTLIGHT_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        inAppSpotlightLoading: false,
        inAppSpotlightSuccess: true,
        error: undefined,
        recommendedApps: data
      };
    }
    case GET_IN_APP_SPOTLIGHT_FAILURE: {
      const { data } = action.payload;

      return {
        ...state,
        inAppSpotlightLoading: false,
        inAppSpotlightSuccess: false,
        error: action.payload,
        recommendedApps: data
      };
    }

    // Get dashboard component
    case GET_DASHBOARD_COMPONENTS_REQUEST:
      return { ...state, dashboardComponentsLoading: true, dashboardComponentsSuccess: false };
    case GET_DASHBOARD_COMPONENTS_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        dashboardComponentsLoading: false,
        dashboardComponentsSuccess: true,
        error: undefined,
        dashboardComponents: data
      };
    }
    case GET_DASHBOARD_COMPONENTS_FAILURE:
      return {
        ...state,
        dashboardComponentsLoading: false,
        dashboardComponentsSuccess: false,
        error: action.payload
      };
    // Get change logs
    case GET_CHANGE_LOGS_REQUEST:
      return { ...state, gettingChangeLogs: true, getChangeLogsSuccess: false };
    case GET_CHANGE_LOGS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        gettingChangeLogs: false,
        getChangeLogsSuccess: true,
        error: undefined,
        changeLogs: data
      };
    }
    case GET_CHANGE_LOGS_FAILURE:
      return {
        ...state,
        gettingChangeLogs: false,
        getChangeLogsSuccess: false,
        error: action.payload
      };
    // Get feature list
    case GET_CROSS_SELL_UP_SELL_REQUEST:
      return { ...state, gettingFeatures: true, getFeaturesSuccess: false };
    case GET_CROSS_SELL_UP_SELL_SUCCESS: {
      const { data } = action.payload;

      return {
        ...state,
        gettingFeatures: false,
        getFeaturesSuccess: true,
        error: undefined,
        features: data
      };
    }
    case GET_CROSS_SELL_UP_SELL_FAILURE:
      return {
        ...state,
        gettingFeatures: false,
        getFeaturesSuccess: false,
        error: action.payload
      };
    case PROCESS_DISMISS_BLOCK_REQUEST: {
      const { blockName } = action.payload;
      const dismissLoading = [...state.dismissLoading, blockName];

      return { ...state, dismissLoading };
    }
    // Process dismiss block
    case PROCESS_DISMISS_BLOCK_SUCCESS: {
      const { blockName, data } = action.payload;
      const dismissLoading = _.remove(state.dismissLoading, blockName);
      const dismissSuccess = [...state.dismissSuccess, blockName];

      return { ...state, dismissLoading, error: undefined, dismissSuccess, dashboardBlocks: data };
    }
    case PROCESS_DISMISS_BLOCK_FAILURE: {
      const { blockName } = action.payload;
      const dismissLoading = _.remove(state.dismissLoading, blockName);

      return {
        ...state,
        dismissLoading,
        error: action.payload
      };
    }
    // Feedback request
    case FEEDBACK_REQUEST: {
      const { blockName } = action.payload;
      const feedbackLoading = [...state.feedbackLoading, blockName];
      return { ...state, feedbackLoading };
    }

    case FEEDBACK_SUCCESS: {
      const { blockName } = action.payload;

      // Remove loading status and update feedback status for selected block
      const feedbackLoading = _.remove(state.feedbackLoading, blockName);
      const feedbackSuccess = [...state.feedbackSuccess, blockName];

      return { ...state, feedbackLoading, feedbackSuccess };
    }

    case FEEDBACK_FAILURE: {
      const { blockName } = action.payload;
      const feedbackLoading = _.remove(state.feedbackLoading, blockName);

      return { ...state, feedbackLoading, error: action.payload };
    }

    case CONFIRM_DISMISS_BLOCK: {
      const { blockName } = action.payload;
      return {
        ...state,
        dashboardBlocks: { ...state.dashboardBlocks, [blockName]: false }
      };
    }
    case UPDATE_DASHBOARD_BLOCK: {
      const { blocks } = action.payload;

      return {
        ...state,
        dashboardBlocks: { ...state.dashboardBlocks, ...blocks }
      };
    }

    case IM_IN_FEEDBACK_5TARS: {
      return {
        ...state,
        isShowPopupImIn: true
      };
    }

    default:
      return state;
  }
};
export default dashboardReducers;
